<template>
    <BreadCrumb PageTitle="Liste des secteurs" />
    <ListeSecteur />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeSecteur from "../../components/Emplacement/ListeSecteur.vue";
    export default defineComponent({
      name: "ListeSecteurPage",
      components: {
        BreadCrumb,
        ListeSecteur,
      },
    });
  </script>